package fr.manyverse.app.presentation.components.notification

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.key
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.delay

const val NOTIFICATION_DURATION_MS = 5000L
const val SWIPE_DISMISS_THRESHOLD = 120f
const val SWIPE_OUT_TARGET = 2000f

@Composable
fun NotificationHost(
    notifications: List<NotificationContent>,
    onDismiss: (NotificationContent) -> Unit,
    modifier: Modifier = Modifier,
    diceTotalEnabled: Boolean = true,
    onClick: (NotificationContent) -> Unit = {}
) {
    Column(
        modifier = modifier,
        verticalArrangement = Arrangement.spacedBy(6.dp)
    ) {
        notifications.forEach { notification ->
            key(notification.id) {
                LaunchedEffect(notification.id) {
                    delay(NOTIFICATION_DURATION_MS)
                    onDismiss(notification)
                }

                AnimatedVisibility(
                    visible = true,
                    enter = slideInVertically { -it } + fadeIn(),
                    exit = slideOutVertically { -it } + fadeOut()
                ) {
                    when (notification) {
                        is NotificationContent.DiceRoll -> DiceRollNotification(
                            notification = notification,
                            totalEnabled = diceTotalEnabled,
                            onDismiss = { onDismiss(notification) }
                        )

                        is NotificationContent.NewMessage -> NewMessageNotification(
                            notification = notification,
                            onDismiss = { onDismiss(notification) },
                            onClick = { onClick(notification) }
                        )

                        is NotificationContent.PlayerJoined -> PlayerJoinedNotification(
                            notification = notification,
                            onDismiss = { onDismiss(notification) }
                        )

                        is NotificationContent.ItemReceived -> ItemReceivedNotification(
                            notification = notification,
                            onDismiss = { onDismiss(notification) },
                            onClick = { onClick(notification) }
                        )
                    }
                }
            }
        }
    }
}